// Copyright © 2025 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import get from 'lodash/get';

const styles = ({ color, margin, padding } = {}) => ({
  nameContainer: {
    margin: `${get(margin, 'm2')} ${get(margin, 'm4')} ${get(margin, 'm2')} ${get(margin, 'm0')} !important`,
    width: 86,
  },
  usernameContainer: {
    margin: `${get(margin, 'm2')} ${get(margin, 'm4')} ${get(margin, 'm2')} ${get(margin, 'm0')} !important`,
    width: 90,
  },
  emailContainer: {
    margin: `${get(margin, 'm2')} ${get(margin, 'm4')} ${get(margin, 'm2')} ${get(margin, 'm0')} !important`,
    width: 175,
  },
  autoContainer: {
    marginTop: `${get(margin, 'm24')} !important`,
    marginRight: `${get(margin, 'm5')}`,
    marginBottom: '0 !important',
    width: 175,
  },
  schemeContainer: {
    margin: `${get(margin, 'm2')} ${get(margin, 'm4')} ${get(margin, 'm2')} ${get(margin, 'm0')} !important`,
    width: 170,
  },
  roleContainer: {
    margin: `${get(margin, 'm2')} ${get(margin, 'm4')} ${get(margin, 'm2')} ${get(margin, 'm0')} !important`,
    width: 105,
  },
  statusContainer: {
    margin: `${get(margin, 'm2')} ${get(margin, 'm4')} ${get(margin, 'm2')} ${get(margin, 'm0')} !important`,
    width: 123,
  },
  inactivityTypeContainer: {
    margin: `${get(margin, 'm2')} ${get(margin, 'm4')} ${get(margin, 'm0')} ${get(margin, 'm0')} !important`,
    width: 120,
  },
  inactivityDaysContainer: {
    margin: `${get(margin, 'm2')} ${get(margin, 'm4')} ${get(margin, 'm0')} -8px !important`,
    width: 70,
  },
  inactivityDaysLabelContainer: {
    margin: `${get(margin, 'm2')} ${get(margin, 'm4')} ${get(margin, 'm0')} -8px !important`,
    width: 110,
  },
  sortContainer: {
    margin: `${get(margin, 'm2')} ${get(margin, 'm4')} ${get(margin, 'm2')} ${get(margin, 'm0')} !important`,
    width: 154,
  },
  selectField: {
    padding: `${get(padding, 'p2')} ${get(padding, 'p10')} !important`,
    width: 100,
  },
  statusIcon: {
    height: 18,
    marginRight: 4,
    verticalAlign: 'middle',
    width: 18,
  },
  statusActive: {
    color: get(color, 'success'),
  },
  statusFirstThreshold: {
    color: get(color, 'attention'),
  },
  statusSecondThreshold: {
    color: get(color, 'warning'),
  },
  statusLastThreshold: {
    color: get(color, 'error'),
  },
  statusInactive: {
    color: get(color, 'disabledBackground'),
  },
  deleteUsersButton: {
    padding: 0,
    backgroundColor: get(color, 'error'),
    color: get(color, 'bodyBackground'),
    '&:hover': {
      backgroundColor: get(color, 'error'),
    },
    '&:focus': {
      backgroundColor: get(color, 'error'),
    },
  },
  bulkDeleteUsers: {
    padding: 10,
  },
  clearButton : {
    margin: `33px ${get(margin, 'm0')} ${get(margin, 'm0')} -8px !important`,
    minWidth : 30,
    maxWidth : 30,
  },
});

export default styles;
